<template>
  <div class="wp_img">
    <div class="preview">
      <img class="bg" :src="bgs[0]">
    </div>
    <div class="preview">
        <div class="chahua ch_0">
          <video></video>
        </div>
      <img class="bg" :src="bgs[1]">
    </div>
    <div class="preview">
        <div class="chahua ch_0">
          <video></video>
        </div>
      <img class="bg" :src="bgs[2]">
    </div>
    <div class="preview">
        <div class="chahua ch_0">
          <video></video>
        </div>
      <img class="bg" :src="bgs[3]">
    </div>
  </div>
</template>

<script>
export default {
  name: "ShiPin",
  data() {
    return {
      bgs: [require('../assets/17.jpg'),require('../assets/18.jpg'),require('../assets/19.jpg'),require('../assets/20.jpg')]
    }
  }
}
</script>

<style scoped lang="less">
.preview{
  width: 100%;
  position: relative;
  overflow: hidden;
  box-sizing: border-box;

  .bg{
    width: 100%;
  }
  .chahua{
    position: absolute;
    top: 0;
    width: 100%;
  }
  .ch_0{
    margin-top: 2rem;
  }
  .ch_1,.ch_2{
    margin-top: 6rem;
  }
}
</style>